import(/* webpackMode: "eager", webpackExports: ["AiAstrologerSection"] */ "/app/apps/web/components/home/AiAstrologerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AskAstrologerBox"] */ "/app/apps/web/components/home/AskAstrologerBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AstroWheelVisual"] */ "/app/apps/web/components/home/AstroWheelVisual.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFaqAccordion"] */ "/app/apps/web/components/home/HomeFaqAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModuleCards"] */ "/app/apps/web/components/home/ModuleCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZodiacTicker"] */ "/app/apps/web/components/home/ZodiacTicker.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
